var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('header', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "head_left",
    style: {
      width: _vm.isMobile ? _vm.collapsed ? '0px' : '208px' : _vm.collapsed ? '70px' : '208px'
    }
  }, [_c('div', {
    staticClass: "logo-wrapper",
    on: {
      "click": function ($event) {
        _vm.isMobile && _vm.collapsedSider();
      }
    }
  }, [_c('HeardLogo', {
    attrs: {
      "collapsed": _vm.collapsed
    }
  })], 1)]), _c('div', {
    staticClass: "head_other"
  }, [_c('div', {
    staticClass: "head_center"
  }, [_c('button', {
    staticClass: "iw-header-icon-btn ml-4",
    on: {
      "click": _vm.collapsedSider
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[20px]"
  }, [_vm._v("menu")])])]), _c('div', {
    staticClass: "head_right"
  }, [_c('div', {
    staticClass: "head_right_actions"
  }, [_c('FootLanguage', {
    staticClass: "iw-header-language"
  }), _c('button', {
    staticClass: "iw-header-icon-btn",
    on: {
      "click": _vm.onOpenHelp
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[18px]"
  }, [_vm._v("help_outline")])]), _c('DownloadCenter'), _c('div', {
    staticClass: "iw-header-divider"
  })], 1), _c('div', {
    staticClass: "user_messge"
  }, [_c('UserMessage')], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };